import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { API } from "./modules/api";
import { WeatherAPI } from "./modules/weather";

export const store = configureStore({
  reducer: {
    [API.reducerPath]: API.reducer,
    [WeatherAPI.reducerPath]: WeatherAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(API.middleware).concat(WeatherAPI.middleware),
});
setupListeners(store.dispatch);
